import React, { FC } from 'react'
import Slider from 'react-slick'
import { TopicCard } from '../../../../models/topics/card'
import { renderRichText } from '../../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'
import Button from '../../button'
import Typography from '../../typography'
import { SLIDER_SETTINGS } from './sliderSettings'

type CardSliderContentProps = {
  cardData: TopicCard[]
  setImageCardNav: any
  mainEyebrow: string
}

export const ContentCardSlider: FC<CardSliderContentProps> = ({
  cardData,
  setImageCardNav,
  mainEyebrow,
}) => {
  return (
    <Slider
      className="slider-for"
      {...SLIDER_SETTINGS.CONTENT_CARDS}
      ref={slider => setImageCardNav(slider)}>
      {cardData?.length > 0 &&
        cardData.map((card, index: number) => {
          return (
            <div key={index}>
              {(card.eyebrow || mainEyebrow) && (
                <Typography type="label" className="CardSlider__Eyebrow">
                  {card.eyebrow || mainEyebrow}
                </Typography>
              )}
              {card.title && (
                <Typography type="header2" className="CardSlider__Title">
                  {formatInlineCode(card.title)}
                </Typography>
              )}
              {card.description && (
                <Typography type="bodyXL" className="CardSlider__Desc">
                  {renderRichText(card.description)}
                </Typography>
              )}

              {card.ctaLink && card.ctaText && (
                <Button
                  icon={true}
                  href={card.ctaLink}
                  text={formatInlineCode(card.ctaText)}
                  type={'text-link'}
                  size="small"
                  theme={'light'}
                  className="CardSlider__Link"
                />
              )}
            </div>
          )
        })}
    </Slider>
  )
}
